export const YOTPO_WIDGET_LOADER_BASE_URL =
  "https://cdn-widgetsrepository.yotpo.com/v1/loader";

export type YotpoLocaleConfig = {
  appKey: string;
  widgetId: string;
  starRating: string;
};

export const yotpoConfigByLocale: Record<string, YotpoLocaleConfig> = {
  "pt-pt": {
    appKey: "dhTPD8ubejM5Wf92MvYEOGU4wIgzmddLIK1fesb8",
    widgetId: "1238633",
    starRating: "1259767",
  },
  "es-es": {
    appKey: "kFq9KjLte5YlLHCcT2pdMes6gQLY0IxXggnURmdZ",
    widgetId: "1238625",
    starRating: "1259336",
  },
  "it-it": {
    appKey: "7H4IWbt0I8gciasDozoAsjfmml8ooxlQPoWWWmIb",
    widgetId: "1238629",
    starRating: "1259760",
  },
  "en-gb": {
    appKey: "aAxFHBKj0C2SbfBJ04YyBKdfGjVVmRjQppoUIQz7",
    widgetId: "1238608",
    starRating: "1259265",
  },
  "en-ie": {
    appKey: "mPV2wsnK8IhX4GOkIl9FoMA7BCD0E4fGIDQr94J7",
    widgetId: "1238609",
    starRating: "1259287",
  },
  "da-dk": {
    appKey: "tYQk0QzQIcjb02hI6SCG6Zn0hZvTA2yDCt1qxEEO",
    widgetId: "1238612",
    starRating: "1259301",
  },
  "sv-se": {
    appKey: "9UVUJzuX71ibkHRUKgAA3YR7D2IDUM0CNVLIq3d5",
    widgetId: "1238634",
    starRating: "1258813",
  },
  "pl-pl": {
    appKey: "GkcfnLPkjTqf5fhIdPeOvCBynYOiXxwpi02Lx4je",
    widgetId: "1238631",
    starRating: "1259762",
  },
  "fr-fr": {
    appKey: "C5FYlKL1mZR5OFNVEJcf0ZIKCCSFAwuXUJ608CMi",
    widgetId: "1238627",
    starRating: "1259356",
  },
  "de-de": {
    appKey: "9ioFYDexd5uJBoFl8BQEP0b1j1Z6n6WEifLaCqJf",
    widgetId: "1238610",
    starRating: "1259290",
  },
  "nl-be": {
    appKey: "Zn8pwK7Bp3VNDrIY4u1Oi3NxXB3ndA9pgklpTct4",
    widgetId: "1238604",
    starRating: "1259253",
  },
  "nl-nl": {
    appKey: "JAwOVgT3tQfKvG6PceMUexkoWu2YAGuSoZzqUmVR",
    widgetId: "1217848",
    starRating: "1217917",
  },
};

export function getYotpoConfig(
  locale: string | undefined
): YotpoLocaleConfig | null {
  if (!locale) {
    return null;
  }
  return yotpoConfigByLocale[locale] ?? null;
}
